import { render, staticRenderFns } from "./OverlayPage.vue?vue&type=template&id=5e158d61"
import script from "./OverlayPage.vue?vue&type=script&lang=js"
export * from "./OverlayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports